var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isEnabled),expression:"isEnabled"}]},[(_vm.activeComponent === 'main')?_c('TestPluginMain',{on:{"setActiveComponent":_vm.setActiveComponent}}):_c('TestPluginView',{on:{"setActiveComponent":_vm.setActiveComponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }